import axios from 'axios';

export default{
    submitContactform(formData) {
        return axios.post("https://hrv.insec.org.np/api/v1/contact-us", formData);
    },
    subscribeEmail(data) {
        return axios.post("https://hrv.insec.org.np/api/v1/subscribe-book", data);
    }
}